import InfoIcon from "Assets/Icons/InfoIcon";
import { Progress } from "reactstrap";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import "./index.css";
import StudentRatingComponent from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentInformance/StudentRatingComponent";
const StyledSpan = styled<any>("div")`
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px !important" : "11px"};
  color: var(--Grey-60, #333);
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
`;
const TotaCountSpan = styled<any>("span")`
  color: var(--grey-70, #545454);
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "12px"};
  font-style: normal;
  font-weight: 600;
  line-height: 25px; /* 156.25% */
  padding-left: 16px;
`;
const getIndicatorColor = (percentage: number) => {
  if (percentage >= 0 && percentage <= 25) {
    return "#E7685A";
  } else if (percentage > 25 && percentage <= 50) {
    return "#FFD47F";
  } else if (percentage > 50 && percentage <= 75) {
    return "#FDA46D";
  } else if (percentage > 75 && percentage <= 100) {
    return "#50B47F";
  } else {
    return "#e9ecef";
  }
};
const ProgressStyled = styled<any>(Progress)`
  background-color: ${(props: any) => props.color + "! important"};
  height: 8px !important;
`;
const StudentAttendanceComponent = ({
  selectedStudent,
  attendanceCount,
  lopDetails,
}: any) => {
  const { screen }: any = useWindowSize();
  const percentage =
    (attendanceCount.attendantClassCount * 100) /
    attendanceCount.totalClassScheduled;
  const returnPercentage = (prevPer: number, currentPer: number) => {
    return currentPer - prevPer;
  };
  return (
    <div className="h-100 w-100 d-flex justify-content-center flex-column">
      <div>
        <div
          className={
            ["xl", "xxl", "lg"].includes(screen)
              ? "classDiv d-flex"
              : "classDiv d-flex pt-2"
          }
        >
          <StyledSpan screen={screen} style={{ width: "40%" }}>
            Class Attendance
            <InfoIcon id={"Tooltip-attendance"}></InfoIcon>
          </StyledSpan>
          <div
            className="d-flex align-items-center classProgressDiv pl-0"
            style={{ width: "40%" }}
          >
            <ProgressStyled
              multi
              className={
                ["xxl", "xl", "lg"].includes(screen)
                  ? "studentProgress"
                  : "studentProgressMB"
              }
            >
              <ProgressStyled
                bar
                color={getIndicatorColor(percentage)}
                value={percentage >= 25 ? 25 : returnPercentage(0, percentage)}
              ></ProgressStyled>
              <ProgressStyled
                bar
                color={getIndicatorColor(percentage)}
                value={
                  percentage > 25 && percentage <= 50
                    ? returnPercentage(25, percentage)
                    : percentage > 50
                    ? 25
                    : 0
                }
              ></ProgressStyled>
              <ProgressStyled
                bar
                color={getIndicatorColor(percentage)}
                value={
                  percentage > 50 && percentage <= 75
                    ? returnPercentage(50, percentage)
                    : percentage > 75
                    ? 25
                    : 0
                }
              ></ProgressStyled>
              <ProgressStyled
                bar
                color={getIndicatorColor(percentage)}
                value={returnPercentage(75, percentage)}
              ></ProgressStyled>
            </ProgressStyled>
          </div>

          <div className="d-flex align-items-center">
            <TotaCountSpan screen={screen}>
              <>
                {attendanceCount.totalClassScheduled > 0 ? (
                  <>
                    {attendanceCount.attendantClassCount}/
                    {attendanceCount.totalClassScheduled}
                  </>
                ) : (
                  "NA"
                )}
              </>
            </TotaCountSpan>
          </div>
        </div>
      </div>
      <div
        className={["xl", "xxl", "lg"].includes(screen) ? "testDiv" : "pt-1"}
      >
        <div className="d-flex align-items-center">
          <StyledSpan screen={screen}>Total Tests Attended :</StyledSpan>
          <span className="pl-2" style={{ fontWeight: "bold" }}>
            {attendanceCount.totalTestGiven || 0}
          </span>
        </div>
      </div>
      <StudentRatingComponent
        selectedStudent={selectedStudent}
        lopDetails={lopDetails}
      />
    </div>
  );
};
export default StudentAttendanceComponent;
